// 三模块锚点id
export enum AboutAnchorEnum {
	PROFILE = "PROFILE", // 公司简介
	CULTURE = "CULTURE", // 企业文化
	TEAM = "TEAM", // 管理团队
}

// 静态图片
export const ABOUTUS_STATIC_IMAGES = {
	bannerPC: require('../../../assets/images/aboutUs/aboutUsPCBanner.jpg'),
    bannerMobile: require('../../../assets/images/aboutUs/aboutUsMobileBanner.jpg'),
	logoBlack: require('../../../assets/images/logo-black.png'),
	jzfzInChinaMapImgURL: require('../../../assets/images/JZFZ-IN-CHINA.png'),
};

/**
 * 公司简介文本,中英文结合
 */
export const COMPANY_PROFILES = [
    "基准方中是致力于城乡高质量发展建设的全过程、全面专业的设计、咨询、管理服务企业。自2002年成"+
    "立以来，秉承“以客户为尊，真诚服务”的理念，聚焦以客户为中心的价值创造，为城乡建设提"+
    "供全面专业的解决方案，创造具有地域文化、人文关怀和充满活力的美好空间。",

    "基准方中总部位于四川成都，在全国拥有23个城市公司，目前持有建筑工程、风景园林和城"+
    "乡规划甲级资质、建筑工程施工承包壹级资质、建筑装修装饰工程专业承包一级资质和市政乙"+
    "级资质，在全国32个省市及自治区数百个城市落地完成了上万个项目，部分项目已成为当地"+
    "的标志性建筑。公司先后荣获“全球设计企业50强”“中国民营勘察设计企业3强”“全国勘察设计"+
    "行业优秀民营设计企业”“当代中国建筑设计百家名院”“四川省优秀民营企业”和“四川省首批总"+
    "部企业”等多项荣誉。",

    "如今，中国经济已步入高质量发展的新周期，民营企业成为推动经济社会发展的重要力量，基"+
    "准方中将继续坚持质量和效益并举，持续创新，开启 “大咨询、大设计、大管理”的基准方中"+
    "2.0时代，为行业的高质量发展贡献基准力量。",

    "JZFZ Architectual Design Co., Ltd is a full-process integrated service enterprise"+
    "dedicated to professional design, consulting, and management for high-quality urban"+ 
    "and rural development.. Since its establishment in 2002, JZFZ has adhered to the philosophy of "+
    "“customer-centric and service-oriented”, focusing on value creation centered on the "+
    "customer providing comprehensive and professional solutions for urban and rural "+
    "construction, and creating vibrant, culturally rich and human centered spaces. ",

    "Headquartered in Chengdu, Sichuan, JZFZ has 23 branches and subsidiaries across China. "+
    "JZFZ holds Class A qualifications in Architectural Engineering, Landscape Architecture, "+ 
    "Urban and Rural planning, General Contracting in Architectural Engineering and "+
    "Professional Contracting for Building Decoration Engineering, as well as a Class B "+
    "qualification for Municipal Engineering. JZFZ has completed tens of thousands of projects in "+
    "hundreds of cities across China, and some of them have become local landmark buildings. "+
    "JZFZ has been honored as “TOP50 Global Design Enterprises”“Top 3 Private Survey and "+
    "Design Enterprises in China”“Outstanding Private Design Enterprise in the National Survey "+
    "and Design industry”“Top 100 Contemporary Chinese Architectural Design institutes”"+
    "“Outstanding Private Enterprise in Sichuan Province” and “The First Batch of Headquarters "+
    "Enterprises in Sichuan Province”. ",
    
    "Now, as China's economy enters a new cycle of high-quality development, private  "+
    "enterprises have become an important force in promoting economic and social progress.  "+
    "JZFZ continues to adhere to both quality and efficiency, and ushers in the 2.0 era of the  "+
    "company focusing on the whole process consulting, design and management services,  "+
    "contributing to the industry's high-quality development."
];


// 领先的文本集合
export const LEADING_CONTENTS = [
    {enTitle: ["Whole-process", "Abilities"], title: ["领先的", "全过程综合设计服务能力"], detail: '以“大咨询、大设计、大管理”三大能力为核心，服务项目全生命周期，提供助力项目长期成功的一站式专业服务。'},
    {enTitle: ["Sector-Specific", "Product and Service Expertise"], title: ["领先的", "细分领域产品服务能力"], detail: '具备住宅、商业、产业园、文教、康养、酒店、体育、城市更新、市政、景观、室内以及工业化、绿建、智能化、海绵、能源管理、灯光、高性能机房等多个细分领域产品专业积淀，能力全面复合。'},
    {enTitle: ["Technological", "Innovation Capability"], title: ["领先的", "科技创新能力"], detail: '形成AI和大数据赋能下的前沿科技创新能力，研发人员占比和科技创新研发成果行业领先，实现设计质量与效率的高水平组合。'},
    {enTitle: ["Benchmark", "Project Achievements"], title: ["领先的", "标杆项目成果影响力"], detail: '成都华润万象城、西安万象城、西安CCBD、西安SKP、重庆万象城、龙湖天街、万科天荟、麓湖黑钰岛、新希望 D10、金茂府,华西坝、猛追湾和少城城市更新、天府匠芯、泰和泰中心等行业标杆项目成果丰硕，深度服务国家和区域发展战略，社会价值和品牌影响力显著。'},
    {enTitle: ["Professional", "Credentials"], title: [" ", "行业资质与权威认可"], detail: '持有建筑工程、风景园林和城乡规划甲级资质、建筑工程施工承包壹级资质，专业资质复合全面。跻身行业全球50强、中国民营企业3强，获评四川省首批总部企业和省优秀民营企业。'},
];

// 发展历程数据配置
export const DEVELOPMENT_HISTORY_LIST = [
    { text: '基准方中建筑设计事务所成立，办公楼位于青羊区冠城广场17F', year: 2002 }, 
    { text: '实现设计产值500万元，位居中国民用建筑设计市场排名第60位，民营榜排名第20位', year: 2003 }, 
    { text: '设计产值首次过亿', year: 2006 }, 
    { text: '位居中国民用建筑设计市场排名第17位，民营榜排名第3位，办公楼搬迁至青羊区新世纪广场', year: 2007 }, 
    { text: '荣获全国勘察设计行业“优秀民营设计企业”称号', year: 2010 }, 
    { text: '1基准方中成立10周年，荣获“当代中国建筑设计百家名院”称号', year: 2012 }, 
    { text: '公司更名为“成都基准方中建筑设计有限公司”，办公楼搬迁至锦江区华润广场A座', year: 2013 }, 
    { text: '全年设计产值突破10亿，荣获“中国十大民营工程设计企业”称号', year: 2016 }, 
    { text: '基准方中成立15周年，荣获“四川省厂务公开民主管理示范单位”称号', year: 2017 }, 
    { text: '取得69亩国有建设用地使用权，投资建设基准方中全球总部入选成都市第一批总部企业名单，荣获“四川省优秀民营企业”称号', year: 2018 }, 
    { text: '通过四川省“高新技术企业”认证，荣获“四川服务业百强企业”称号，2021ENR中国工程设计企业60强排名第18位', year: 2021 }, 
    { text: '基准方中成立20周年，公司更名为“基准方中建筑设计股份有限公司”开启“大咨询 大设计 大管理”的基准方中2.0时代', year: 2022 }, 
    { text: '荣获“中国十大民营工程设计企业”称号', year: 2023 }, 
    { text: '基准方中全球总部“天府匠芯”落成', year: 2024 }, 
];

// JZFZ在中国
export const JZFZ_IN_CHINA = {
    title: '基准方中在中国',
    enTitle: 'JZFZ IN CHINA',
    details: [
        { amount: '2002', incident: '公司成立时间' },
        { amount: '23', incident: '城市公司' },
        { amount: '300+', incident: '项目落地城市' },
        { amount: '10000+', incident: '服务项目' },
    ]
};
/**
 * 企业荣誉图片配置
 */
export const COMPANY_HONER_IMAGES = {
    usuallyEmpty: require('@/assets/images/aboutUs/usuallyEmpty.png'),
    usuallyHover1: require('@/assets/images/aboutUs/usuallyHover1.png'),
    usuallyHover2: require('@/assets/images/aboutUs/usuallyHover2.png'),
    usually3: require('@/assets/images/aboutUs/usually3.png'),
    usuallyHover3: require('@/assets/images/aboutUs/usuallyHover3.png'),
    usually4: require('@/assets/images/aboutUs/usually4.png'),
    usuallyHover4: require('@/assets/images/aboutUs/usuallyHover4.png'),
    usually5: require('@/assets/images/aboutUs/usually5.png'),
    usuallyHover5: require('@/assets/images/aboutUs/usuallyHover5.png'),
    usually6: require('@/assets/images/aboutUs/usually6.png'),
    usuallyHover6: require('@/assets/images/aboutUs/usuallyHover6.png'),
    usuallyHover7: require('@/assets/images/aboutUs/usuallyHover7.png'),
    usuallyHover8: require('@/assets/images/aboutUs/usuallyHover8.png'),
};